<template>
    <div>
        <Flipbook
        v-if="$route.params.showMagazine"
        class="flipbook"
        :pages="$route.params.pages"
        v-slot="flipbook"
        >
        <button type="button" class="close closeMagazine" @click="closeMagazine" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
        <div class="action-bar">
            <span
            class="btn icon-arrow-left"
            :class="{ disabled: !flipbook.canFlipLeft }"
            @click="flipbook.flipLeft"
            ></span>
            <span
            class="btn icon-zoom_out"
            :class="{ disabled: !flipbook.canZoomOut }"
            @click="flipbook.zoomOut"
            ></span>
            <span class="page-num">
            Page {{ flipbook.page }} of {{ flipbook.numPages }}
            </span>
            <span
            class="btn icon-zoom_in"
            :class="{ disabled: !flipbook.canZoomIn }"
            @click="flipbook.zoomIn"
            ></span>
            <span
            class="btn icon-arrow-right"
            :class="{ disabled: !flipbook.canFlipRight }"
            @click="flipbook.flipRight"
            ></span>
        </div>
        </Flipbook>
    </div>
</template>

<script>
// import Flipbook from "flipbook-vue";
    export default {
        name: "SingleMagazine",
        props: ['active'],
        components:{
            // Flipbook,
        },
        data:{
        },
        methods:{
            closeMagazine: function(){
                console.log('retorna');
                this.$router.push({
                    name: 'magazine',
                    params: { active: true },
                });
            }
        }
    }
</script>

<style lang="scss">
.flipbook {
    margin: 2% 0 4% 0;
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: white;
    margin: 0;
    padding: 1% 0;
    top: 0;
    z-index: 10000000000;
    overflow-x: hidden;
}
.action-bar {
  width: 100%;
  height: 30px;
  padding: 10px 0 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 767px) {
  .action-bar {
    width: 100%;
    height: 35px;
    padding: 15px 0 15px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.action-bar .btn {
  font-size: 30px;
  color: #999;
}
.action-bar .btn svg {
  bottom: 0;
}
.action-bar .btn:not(:first-child) {
  margin-left: 10px;
}
.has-mouse .action-bar .btn:hover {
  color: #ccc;
  filter: drop-shadow(1px 1px 5px #000);
  cursor: pointer;
}
.action-bar .btn:active {
  filter: none !important;
}
.action-bar .btn.disabled {
  color: #666;
  pointer-events: none;
}
.action-bar .page-num {
  font-size: 12px;
  margin-left: 10px;
}
.close.closeMagazine{
    position: absolute;
    top: 1%;
    right: 1%;
    font-size: 1.8rem;
    font-weight: 900;
}
</style>